"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./endpoint"));
__export(require("./helper/preset"));
exports.stage = 'test';
if (typeof process !== 'undefined' && process.env.STAGE === 'prod') {
    exports.stage = 'prod';
}
//# sourceMappingURL=index.js.map